import { CalendarDays, List } from 'lucide-react';

/**
 * Bandeau de titre de l'écran mobile actif (sous le header) : icône +
 * libellé de l'onglet, barre d'accent. À droite, la bascule « Liste |
 * Calendrier » pour les écrans qui la proposent (`onViewModeChange`).
 */
export default function MobileScreenTitle({ Icon, label, viewMode, onViewModeChange }) {
  return (
    <div className="m-titlebar">
      <span className="m-titlebar__accent" aria-hidden="true" />
      {Icon ? <Icon size={20} className="m-titlebar__icon" aria-hidden="true" /> : null}
      <h1 className="m-titlebar__label">{label}</h1>
      {onViewModeChange ? (
        <div className="m-viewtoggle" role="group" aria-label="Mode d’affichage">
          <button
            type="button"
            className="m-pill m-viewtoggle__pill"
            data-active={viewMode === 'list'}
            aria-pressed={viewMode === 'list'}
            title="Vue liste (semaine)"
            aria-label="Vue liste"
            onClick={() => onViewModeChange('list')}
          >
            <List size={15} />
            <span className="m-viewtoggle__text">Liste</span>
          </button>
          <button
            type="button"
            className="m-pill m-viewtoggle__pill"
            data-active={viewMode === 'calendar'}
            aria-pressed={viewMode === 'calendar'}
            title="Vue calendrier (mois)"
            aria-label="Vue calendrier"
            onClick={() => onViewModeChange('calendar')}
          >
            <CalendarDays size={15} />
            <span className="m-viewtoggle__text">Calendrier</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
